import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';
import green from '@material-ui/core/colors/green';
import indigo from '@material-ui/core/colors/indigo';

import Domain from './Domain';
import Main from './Main';
import PortfolioCards from './Portfolio';
import WebsiteServiceCards from './Services';
import WebsiteTestimonialCards from './Testimonials';
import {
  PortfolioDialog,
  ServiceDialog,
  TestimonialDialog,
} from './Dialogs';

import { getHostingURL } from 'utils';
import { startEditOrgDomain } from 'store/actions/orgDomains';
import * as routes from '../../../constants/routes';
import { generateWebsiteTemplate } from '../../../store/generators';
import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  row: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionButton: {
    position: 'relative',
    left: '-300px',
    top: '35px',
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    position: 'relative',
    left: '-300px',
    top: '35px',
  },
  avatar: {
    margin: theme.spacing.unit,
    color: '#fff',
    backgroundColor: indigo[100],
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  client: {
    minWidth: '100px',
  },
  wrapper: {
    position: 'relative',
    marginRight: theme.spacing.unit*5,
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
  },
  previewButton: {
    marginRight: theme.spacing.unit*2,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,

  }
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};


class WebsiteDetail extends Component {
  timer = null;

  constructor(props){
    super(props);
    this.state = {
      selectedTab: "main",
      loading: false,
      success: false,
      showValidation: false,
      showConfirmView: false,
    }

  }

  handleChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  onDataChange = () => {
    this.setState({
      loading: false,
      success: false,
    });
  }

  getURL = (isPreview) => {
    const { website, orgDomain } = this.props;
    const { subDomain, customDomain } = website.root;
    const domain = website.root.domain;
    let URL;
    const hostingURL = getHostingURL();

    if (
      orgDomain.customDomain &&
      customDomain === orgDomain.customDomain &&
      orgDomain.customDomainStatus === "approved"
    ) {
      console.log("CUSTOM DOMAIN APPROVED:", orgDomain.customDomain);
      return `https://${orgDomain.customDomain}`;
    } else if(
      orgDomain.subDomain &&
      subDomain === orgDomain.subDomain &&
      orgDomain.subDomainStatus === "approved"
    ) {
      console.log("SUBDOMAIN APPROVED:", orgDomain.subDomain);
      return `https://${orgDomain.subDomain}.couraggo.com`;
    } else {
      return `${hostingURL}/${subDomain ? subDomain : customDomain}${isPreview ? '?preview=1' : ''}`;
    }


  }

  handleViewClick = () => {
    const { website, orgDomain } = this.props;
    const { subDomain, customDomain } = website.root;
    const domain = website.root.domain;
    let URL;
    const hostingURL = getHostingURL();

    if (
      orgDomain.customDomain &&
      customDomain === orgDomain.customDomain &&
      orgDomain.customDomainStatus === "approved"
    ) {
      console.log("CUSTOM DOMAIN APPROVED:", orgDomain.customDomain);
      window.open(`https://${orgDomain.customDomain}/?preview=1`, '_blank');
    } else if(
      orgDomain.subDomain &&
      subDomain === orgDomain.subDomain &&
      orgDomain.subDomainStatus === "approved"
    ) {
      console.log("SUBDOMAIN APPROVED:", orgDomain.subDomain);
      window.open(`https://${orgDomain.subDomain}.couraggo.com/?preview=1`, '_blank');
    } else {
      const viewURL = `${hostingURL}/${subDomain ? subDomain : customDomain}`;
      window.open(viewURL, '_blank');
    }
  }

  handlePreviewClick = () => {
    const {
      oid,
      website,
      orgDomain,
      validation,
      help,
      startEditOrgDomain
    } = this.props;
    const { domain, subDomain, customDomain } = website.root;

    if (!(help.currentMission && help.currentMission.inProgress) && validation.isInvalid) {
      this.setState({ showValidation: true });
      return;
    }

    if (subDomain || customDomain) {
      startEditOrgDomain( oid, { subDomain, customDomain });
    }
    const generateDefaultData = help.currentMission && help.currentMission.inProgress;
    const clonedWebsite = JSON.parse(JSON.stringify(website));
    console.log("website:", clonedWebsite);
    const services = clonedWebsite.services;
    const testimonials = clonedWebsite.testimonials;
    const portfolio = clonedWebsite.portfolio;
    const root = clonedWebsite.root;

    const setDefault = (property, defaultValue) => !property ? defaultValue : property;
    //generate default data for root information
    if (generateDefaultData){
      root.companyName = setDefault(root.companyName, "Company Name");
      root.contactName = setDefault(root.contactName, "Your Name");
      root.email = setDefault(root.email, "youremail@couraggo.com");
      root.heading = setDefault(root.heading, "Some Heading");
      root.phone = setDefault(root.phone, "555 555 5555");
      root.tagline = setDefault(root.tagline, "Some Tagline Here");
      root.location = setDefault(root.location, "Your Location");
    }

    // console.log("ROOT:", root);
    // console.log("clonedWebsite:", clonedWebsite);

    if (generateDefaultData && !services.length) {
      services.push({
        icon: "i8-ant",
        title: "Some Title",
        description: "Some service description",
        show: true,
      });
      services.push({
        icon: "i8-carrot",
        title: "Some Title",
        description: "Some service description",
        show: true,
      });
      services.push({
        icon: "i8-oak-tree",
        title: "Some Title",
        description: "Some service description",
        show: true,
      });
      services.push({
        icon: "i8-strawberry",
        title: "Some Title",
        description: "Some service description",
        show: true,
      });
      services.push({
        icon: "i8-truck",
        title: "Some Title",
        description: "Some service description",
        show: true,
      });
    }

    if(generateDefaultData && !testimonials.length) {
      testimonials.push({
        description: "Aenean imperdiet purus vitae dui venenatis faucibus. Nunc ut purus eu nibh maximus maximus. Nunc egestas sollicitudin elit, in fermentum nisl porta a. Cras eget blandit sem, a faucibus mi. Nulla sagittis, nibh in sodales dictum, arcu nunc tincidunt elit, ut bibendum eros magna pulvinar augue. Sed venenatis urna eu enim suscipit, nec rhoncus tellus pretium. Proin pellentesque et turpis vel aliquam. In efficitur placerat lacinia.",
        location: "Location 1",
        name: "Name 1",
        show: true,
        title: "Testimonial 1",
      });
      testimonials.push({
        description: "Aenean imperdiet purus vitae dui venenatis faucibus. Nunc ut purus eu nibh maximus maximus. Nunc egestas sollicitudin elit, in fermentum nisl porta a. Cras eget blandit sem, a faucibus mi. Nulla sagittis, nibh in sodales dictum, arcu nunc tincidunt elit, ut bibendum eros magna pulvinar augue. Sed venenatis urna eu enim suscipit, nec rhoncus tellus pretium. Proin pellentesque et turpis vel aliquam. In efficitur placerat lacinia.",
        location: "Location 2",
        name: "Name 2",
        show: true,
        title: "Testimonial 2",
      });
      testimonials.push({
        description: "Aenean imperdiet purus vitae dui venenatis faucibus. Nunc ut purus eu nibh maximus maximus. Nunc egestas sollicitudin elit, in fermentum nisl porta a. Cras eget blandit sem, a faucibus mi. Nulla sagittis, nibh in sodales dictum, arcu nunc tincidunt elit, ut bibendum eros magna pulvinar augue. Sed venenatis urna eu enim suscipit, nec rhoncus tellus pretium. Proin pellentesque et turpis vel aliquam. In efficitur placerat lacinia.",
        location: "Location 2",
        name: "Name 2",
        show: true,
        title: "Testimonial 2",
      });
    }

    if(generateDefaultData && !portfolio.length) {
      portfolio.push({
        category: "Category1",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio1.png?alt=media&token=4d3c295c-d558-4c9d-8f8d-6db24e7ba0a5",
        show: true,
        title: "Portfolio 1",
      });
      portfolio.push({
        category: "Category1",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio2.png?alt=media&token=73cdfb1d-bdba-4619-a76d-54f18a3ddf26",
        show: true,
        title: "Portfolio 2",
      });
      portfolio.push({
        category: "Category1",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio3.png?alt=media&token=da17737b-e5c5-412d-8c90-7055ad352927",
        show: true,
        title: "Portfolio 3",
      });
      portfolio.push({
        category: "Category2",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio2.png?alt=media&token=73cdfb1d-bdba-4619-a76d-54f18a3ddf26",
        show: true,
        title: "Portfolio 4",
      });
      portfolio.push({
        category: "Category2",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio1.png?alt=media&token=4d3c295c-d558-4c9d-8f8d-6db24e7ba0a5",
        show: true,
        title: "Portfolio 5",
      });
      portfolio.push({
        category: "Category3",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio3.png?alt=media&token=da17737b-e5c5-412d-8c90-7055ad352927",
        show: true,
        title: "Portfolio 6",
      });
      portfolio.push({
        category: "Category3",
        downloadURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/portfolio1.png?alt=media&token=4d3c295c-d558-4c9d-8f8d-6db24e7ba0a5",
        show: true,
        title: "Portfolio 7",
      });
    }
    //console.log("website after:", clonedWebsite);
    const template = generateWebsiteTemplate(clonedWebsite);
    const hostingURL = getHostingURL();
    console.log("FETCH PREVIEW URL:", hostingURL);

    fetch(`${hostingURL}/preview`, {
      mode: 'no-cors',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        oid,
        domain,
        subDomain,
        customDomain,
        template,
        token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
      })
    })
    .then(response => {
      // console.log("TEST1:", orgDomain);
      // console.log("subDomain:", subDomain);
      // console.log("customDomain:", customDomain);
      if (
        orgDomain.customDomain &&
        customDomain === orgDomain.customDomain &&
        orgDomain.customDomainStatus === "approved"
      ) {
        console.log("CUSTOM DOMAIN APPROVED:", orgDomain.customDomain);
        window.open(`https://${orgDomain.customDomain}/?preview=1`, '_blank');
      } else if(
        orgDomain.subDomain &&
        subDomain === orgDomain.subDomain &&
        orgDomain.subDomainStatus === "approved"
      ) {
        console.log("SUBDOMAIN APPROVED:", orgDomain.subDomain);
        window.open(`https://${orgDomain.subDomain}.couraggo.com/?preview=1`, '_blank');
      } else {
        window.open(`${hostingURL}/${subDomain ? subDomain : customDomain}?preview=1`, '_blank');
      }

    })
    .catch(error => {
      console.log("ERROR:", error);
    });
  }

  //TODO: handle response codes
  handleButtonClick = () => {
    if (!this.state.loading) {
      const { oid, website, validation, startEditOrgDomain } = this.props;
      const { domain, subDomain, customDomain } = website.root;

      if (validation.isInvalid) {
        this.setState({ showValidation: true });
        return;
      }

      if (subDomain || customDomain) {
        startEditOrgDomain( oid, { subDomain, customDomain });
      }

      const template = generateWebsiteTemplate(website);
      const hostingURL = `${getHostingURL()}/publish`;

      this.setState(
        {
          success: false,
          loading: true,
        },
        () => {
          //console.log("FETCH publishURL:", publishURL);
          fetch(hostingURL, {
            mode: 'no-cors',
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              oid,
              domain,
              subDomain,
              customDomain,
              template,
              token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
            })
          })
          .then(response => {
            this.setState({
              loading: false,
              success: true,
              showConfirmView: true,
            });
          })
          .catch(error => {
            console.log("ERROR:", error);
            this.setState({
              loading: false,
              success: false,
              showConfirmView: false,
            });
          });
        },
      );
    }
  };

  render() {
    const { classes, client, history, website, help } = this.props;
    const {
      selectedTab,
      service,
      testimonial,
      portfolioItem,
      loading,
      success,
      showValidation,
      showConfirmView,
    } = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });

    return (
      <div className={classes.root}>
        {showConfirmView &&
          <Dialog
            open={true}
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
          >
            <DialogTitle>Site Published</DialogTitle>
            <DialogContent>
              <Typography>
                Do you want to view the published site?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ showConfirmView: false })}>
                Cancel
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  const URL = this.getURL(false);
                  window.open(URL, '_blank');
                  this.setState({ showConfirmView: false });
                }}
              >
                View
              </Button>
            </DialogActions>
          </Dialog>
        }
        {service &&
          <ServiceDialog
            service={service}
            handleClose={() => this.setState({service: undefined})}
            handleChange={(propertyName, value) => {
              this.onDataChange();
              this.setState(function(prevState, props){
                 return {
                   service: {
                     ...prevState.service,
                     [propertyName]: value,
                   }
                 }
              });
            }}
          />
        }
        {testimonial &&
          <TestimonialDialog
            testimonial={testimonial}
            handleClose={() => this.setState({testimonial: undefined})}
            handleChange={(propertyName, value) => {
              this.onDataChange();
              this.setState(function(prevState, props){
                 return {
                   testimonial: {
                     ...prevState.testimonial,
                     [propertyName]: value,
                   }
                 }
              });
            }}
          />
        }
        {portfolioItem &&
          <PortfolioDialog
            portfolioItem={portfolioItem}
            handleClose={() => this.setState({portfolioItem: undefined})}
            handleChange={(propertyName, value) => {
              this.onDataChange();
              this.setState(function(prevState, props){
                 return {
                   portfolioItem: {
                     ...prevState.portfolioItem,
                     [propertyName]: value,
                   }
                 }
              });
            }}
          />
        }
        <Card className={classes.card}>
          <div className={classes.row}>
            <div className={classes.header}>
              <Avatar className={classNames(classes.avatar, classes.margin)}>
                W
              </Avatar>
              <div className={classes.client}>
                {website &&
                  <Typography variant="subheading">
                    {website.companyName}
                  </Typography>
                }
              </div>
            </div>
            <div className={classes.buttons}>
              <Tooltip type={TooltipTypes.website.ACTIONS} placement="left">
                <div />
              </Tooltip>
              <Tooltip type={TooltipTypes.website.PREVIEW} placement="right">
                <Button
                  variant="contained"
                  color="primary"
                  className={classNames(classes.previewButton, help.isCurrentStep(TooltipTypes.website.PREVIEW) && classes.elevate)}
                  onClick={ () => {
                    helpDispatch(TooltipTypes.website.PREVIEW);
                    return this.handlePreviewClick();
                  }}
                >
                  preview
                </Button>
              </Tooltip>
              {true &&
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.previewButton}
                  onClick={this.handleViewClick}
                >
                  View Site
                </Button>
              }
              <div className={classes.wrapper}>
                <Tooltip type={TooltipTypes.website.INFO_PUBLISH} placement="bottom">
                  <Button
                    variant="contained"
                    color="primary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={this.handleButtonClick}
                  >
                    Publish
                  </Button>
                </Tooltip>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
            </div>
          </div>

        </Card>
        <AppBar position="static" color="default">
          <Tabs
            value={selectedTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
          >
            <Tab label="Main" value="main"/>
            <Tab label="Domain" value="domain"/>
            <Tab label="Services" value="services"/>
            <Tab label="Testimonials" value="testimonials"/>
            <Tab label="Portfolio" value="portfolio"/>
          </Tabs>
        </AppBar>

        {selectedTab === "summary" &&
          <TabContainer>
            <div>Summary</div>
          </TabContainer>
        }
        {selectedTab === "main" &&
          <TabContainer>
            <Main showValidation={showValidation} onDataChange={this.onDataChange.bind(this)} />
          </TabContainer>
        }
        {selectedTab === "domain" &&
          <TabContainer>
            <Domain showValidation={showValidation} onDataChange={this.onDataChange.bind(this)} />
          </TabContainer>
        }

        {selectedTab === "services" &&
          <TabContainer>
            <WebsiteServiceCards
              handleDialog={(service) => this.setState({service: service})}
            />
          </TabContainer>
        }
        {selectedTab === "testimonials" &&
          <TabContainer>
            <WebsiteTestimonialCards
              handleDialog={(testimonial) => this.setState({testimonial: testimonial})}
            />
          </TabContainer>
        }
        {selectedTab === "portfolio" &&
          <TabContainer>
            <PortfolioCards
              handleDialog={(portfolioItem) => this.setState({portfolioItem: portfolioItem})}
            />
          </TabContainer>
        }
        {selectedTab === "sales" &&
          <TabContainer>
            <div>Sales</div>
          </TabContainer>
        }

      </div>
    );
  }
}

WebsiteDetail.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const website = state.websiteState;
  const validation = state.validation.website;
  const organization = state.accountState.organizations[0];
  const oid = organization ? organization.id : undefined;
  const orgDomains = state.orgDomains;
  let orgDomain = {};
  orgDomains.forEach(item => {
    if (oid && item.oid === oid) {
      orgDomain = item;
    }
  });

  return({
    website,
    validation,
    help: state.help,
    oid,
    orgDomain,
  });
};

const mapDispatchToProps = {
  startEditOrgDomain,
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(WebsiteDetail);



// WEBPACK FOOTER //
// ./src/components/admin/Website/WebsiteDetail.jsx